"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _WishListButton = _interopRequireDefault(require("./templates/WishListButton.html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var WishListButton =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(WishListButton, _Backbone$View);

  _createClass(WishListButton, [{
    key: "contrastClass",
    get: function get() {
      return this.contrast === 'default' ? '' : 'contrast-alternate';
    }
  }, {
    key: "ariaLabel",
    get: function get() {
      var title = this.model.attributes.title;
      return this.model.get('wishlistState') === 'wishlistAdd' ? window.html('addTitleToWishList', {
        title: title
      }) : window.html('removeTitleFromWishList', {
        title: title
      });
    }
  }, {
    key: "iconClass",
    get: function get() {
      return this.model.get('wishlistState') === 'wishlistAdd' ? 'icon-wish-list' : 'icon-wish-list-added';
    }
  }, {
    key: "text",
    get: function get() {
      if (this.type === 'icon-only') {
        return '';
      }

      return this.model.get('wishlistState') === 'wishlistAdd' ? window.html('addToWishList') : window.html('removeFromWishList');
    }
  }, {
    key: "ga",
    get: function get() {
      var isAdd = this.model.get('wishlistState') === 'wishlistAdd';

      if (isAdd) {
        return {
          mediaId: this.model.attributes.id,
          formatType: this.model.attributes.type.id
        };
      }

      return null;
    }
  }]);

  function WishListButton(_ref) {
    var _this;

    var type = _ref.type,
        contrast = _ref.contrast;

    _classCallCheck(this, WishListButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WishListButton).apply(this, arguments));
    _this.type = type || 'icon-only';
    _this.contrast = contrast || 'default';

    _this.listenTo(_this.model, 'change:wishlistState', _this.render);

    _this.type = type || 'icon-only';
    return _this;
  }

  _createClass(WishListButton, [{
    key: "events",
    value: function events() {
      return {
        'click': '_handleClick'
      };
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.el || this.$el.length < 1) {
        return; // we have no target to render anything into
      } // retain focus on rerender


      var needsRefocus = this.el.querySelector('.WishListButton') === document.activeElement;
      this.$el.empty(); // LHTNG-1648 - Dont render wishlist icon on recommend* state titles

      if (_(['recommend', 'recommended']).contains(this.model.get('titleState'))) {
        return this;
      }

      var buttonHtml = (0, _WishListButton["default"])({
        ga: this.ga,
        contrastClass: this.contrastClass,
        ariaLabel: this.ariaLabel,
        iconClass: this.iconClass,
        text: this.text
      });
      this.$el.append(buttonHtml);

      if (needsRefocus) {
        this.el.querySelector('.WishListButton').focus();
      }

      return this;
    }
  }, {
    key: "_handleClick",
    value: function _handleClick() {
      this.model.trigger('title:action', {
        action: 'wish',
        model: this.model
      });

      this._animate();
    }
  }, {
    key: "_animate",
    value: function _animate() {
      this.$el.find('i').removeClass('animated bounceIn bounceOut').addClass('animated bounceOut');
    }
  }]);

  return WishListButton;
}(Backbone.View);

exports["default"] = WishListButton;